import React from 'react'
import PropTypes from 'prop-types'

const ShareIcon = ({
  width,
  height,
  color,
  title,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 23 32"
    fill={color}
  >
    <title>{title}</title>
    <path d="M15.7 20.8l2.9-2V22q0 1.2-.9 2.1t-2 .9H2.6q-1.2 0-2-.9T-.3 22V10.1q0-1.2.9-2.1t2-.9h8.2v1.2q-2.6.4-4.5 1.8H2.5V22h13.1v-1.2zm7-8.2q.2.2.2.4 0 .3-.2.4l-9.2 6.5q-.1.1-.3.1-.1 0-.2-.1-.3-.1-.3-.4V16q-1.6 0-2.9.3t-2 .5-1.3.6-.8.5-.3.3q-.1.2-.4.2h-.1q-.3-.1-.4-.5 0-3.3 1.9-5.4 2.2-2.4 6.3-2.5V6.5q0-.3.3-.4.3-.2.5 0z" />
  </svg>
)

ShareIcon.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  color: PropTypes.string,
  title: PropTypes.string,
}

ShareIcon.defaultProps = {
  width: 23,
  height: 32,
  color: 'currentColor',
  title: 'Share by email',
}

export default ShareIcon
